
import React from "react";

const BackToTop = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50">
      <a 
        href="#top" 
        className="flex items-center justify-center w-12 h-12 bg-elfRed text-white rounded-full shadow-lg hover:bg-elfRed/90 transition-all transform hover:scale-105"
        aria-label="Back to top"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </a>
    </div>
  );
};

export default BackToTop;
